import EditComment from './EditComment';

export default EditComment;
